export interface OverviewStatus {
  status: string;
  label: string;
  detail: string;
}

export interface OverviewMetrics {
  tasks: number;
  succeeded: number;
  failed: number;
  successRate: number;
}

export interface SiteOverviewDTO {
  site: { id: string; name: string; primaryUrl?: string; siteType: string; status: string; legacyProjectId?: number };
  connection: OverviewStatus;
  publish: OverviewStatus;
  knowledge: OverviewStatus;
  quota: OverviewStatus;
  knowledgeCount: number;
  today: OverviewMetrics;
  sevenDays: OverviewMetrics;
  recentFailures: Array<{ executionId: string; intent: string; errorCode: string; occurredAt: string }>;
  advice: { code: string; title: string; evidence: string; impact: string; action: string; path: string };
}

export type OverviewTone = "success" | "warning" | "neutral" | "danger";

export function overviewTone(status: string): OverviewTone {
  if (["healthy", "ready", "available", "owner_canary", "legacy_connected", "legacy_active"].includes(status)) return "success";
  if (["attention", "suspended"].includes(status)) return "danger";
  if (["not_connected", "draft", "empty"].includes(status)) return "warning";
  return "neutral";
}

export function siteOverviewPath(siteId: string, relativePath = ""): string {
  const base = `/sites/${encodeURIComponent(siteId)}`;
  const cleaned = relativePath.replace(/^\/+/, "");
  return cleaned ? `${base}/${cleaned}` : base;
}

export function percent(value: number): string {
  if (!Number.isFinite(value)) return "0%";
  return `${Math.round(Math.min(1, Math.max(0, value)) * 100)}%`;
}
